import $api from '@/api'

// 获取所有V2ray信息
export const getAllV2ray = (): any => {
  return $api.get('/v2ray')
}

// 获取所有V2ray更新信息
// export const getUpdateV2ray = pageNumber => {
//   return $api.get('/updates', { pageNumber })
// }
